import { BaseField } from './BaseField';

const imgPlotIcon = "/assets/plot-icon.svg";

export class PlotField extends BaseField {
  constructor() {
    super({
      key: 'plot',
      icon: imgPlotIcon,
      defaultLabel: 'Pow. działki'
    });
  }

  renderForList(property) {
    const plot = property.specifications.features.plot;

    if (plot?.available && plot.area > 0) {
      return { label: 'Pow. działki', value: `${plot.area} m²` };
    }
    return { label: 'Pow. działki', value: 'brak' };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
